export const LINEAGE_FLOW_VISIBLE_BUFFER = 0.25;
export const LINEAGE_FLOW_SKELETON_BUFFER = 0.5;
export const LINEAGE_FLOW_HIDDEN_BUFFER = 0.75;

export const LINEAGE_FLOW_DEBOUNCE_TIME = 500;
export const LINEAGE_FLOW_MAX_NODES_BEFORE_VIRTUALIZATION = 100;

export const LINEAGE_FLOW_DEPTH_LOCAL_STORAGE_KEY = 'secoda-lineage-flow-depth';
